export default "__VITE_ASSET__8w1MGwL5__"